import { useMotionValueEvent, useScroll } from 'framer-motion';
import { useState } from 'react';

const DEFAULT_COMPACT_AFTER_PX = 16;
const DEFAULT_EXPAND_BEFORE_PX = 4;

export const useScrollCompactNavBar = (
  compactAfterPx = DEFAULT_COMPACT_AFTER_PX,
  expandBeforePx = DEFAULT_EXPAND_BEFORE_PX
): boolean => {
  const { scrollY } = useScroll();
  const [compact, setCompact] = useState(() =>
    typeof window !== 'undefined' ? window.scrollY > compactAfterPx : false
  );

  useMotionValueEvent(scrollY, 'change', latest => {
    setCompact(previous => (previous ? latest > expandBeforePx : latest > compactAfterPx));
  });

  return compact;
};
